jQuery(function($)
{
    /**
	 * @type {object jQuery}
	 */
    // var $quantityCheck = $('.js-quantity-check');

    /**
	 * @type {object jQuery}
	 */
    var $body = $('body');

    /**
	 * @type {Number}
	 */
    var quantityLimit = 199;

    /**
	 * Get quantity input value
	 * @param  {object jQuery} $quantityInput Quantity input element
	 * @return {number} Value of quantity input
	 */
    function fetchQuantity($quantityInput)
    {
        return $quantityInput.val();
    }

    /**
	 * Show/hide tooltip, if input value is less 200 or more than 199
	 */
    function handleTooltip()
    {
        var $quantityInput = $(this);
        var $quantityCheckTooltip = $(document).find('[data-tooltip-for-id=\'' + $quantityInput.attr('id') + '\']');
        var quantity = fetchQuantity($quantityInput);

        if ($quantityCheckTooltip.length >= 1)
        {
            if (quantity > quantityLimit)
            {
                var $quantityElement = $quantityCheckTooltip.find('.tooltipQuantityChange');

                $quantityElement.text(quantity);

                $quantityInput.attr('aria-describedby', 'quantity-tooltip');

                $quantityCheckTooltip.tooltip().showTooltip();
            }
            else
            {
                $quantityInput.removeAttr('aria-describedby');

                $quantityCheckTooltip.tooltip().hideTooltip();
            }
        }
    }

    /**
	 * Add event for product elements created after AJAX request
	 * @param  {object} event Event data
	 * @param  {object} data  Product data
	 */
    function handleProductCreated(event, data)
    {
        $body.on('change keyup focus', '#' + data.productNumber, handleTooltip);
    }

    /**
	 * Initialize events
	 */
    function initEvents()
    {
        $('.js-quantity-check').on('change keyup focus', handleTooltip);
        $body.on(orion.constants.EventCartProductCreated, handleProductCreated);
    }

    /**
	 * Initialize quantity check
	 */
    function init()
    {
        initEvents();
    }

    init();

    let shoppingListTable = $('.js-shoppinglist');
    if (shoppingListTable.length >= 1)
    {
        shoppingListTable.DataTable().on('draw', initEvents);
    }

    let checkoutCartTable = $('.js-basket');
    if (checkoutCartTable.length >= 1)
    {
        checkoutCartTable.DataTable().on('draw', initEvents);
    }
});
